import { gql } from '@apollo/client'

export const TERRA_PROVIDER = gql`
  fragment TerraProvider on Provider {
    provider
    active
    connectionId
    name
    status
    errorReason
    availableTypes
    disabledTypes
    providerKind
  }
`
